// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/assets/js/router'
import routes from './router'
import Vant from 'vant'
import VConsole from 'vconsole'
import wxInit from './assets/js/weixin-sdk'
import 'vant/lib/index.css'
import '@/assets/css/common.css'
import '@/assets/js/rem'

Vue.use(Vant)
Vue.use(wxInit)

// 调试工具
if (!window.location.hostname.includes('cangoonline.net')) {
  // eslint-disable-next-line no-new
  new VConsole()
}

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router(routes),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js